import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Cookies from "js-cookie";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/index'
    },
    {
        path: "/home",
        name: "home",
        component: () => import("@/views/home.vue"),
        meta: { breadcrumb: "首页" },
        redirect: "/apply/CityAgent",
        children:[
            {
                path: "/website",
                name: "website",
                meta: { breadcrumb: "官网管理" },
                component: () => import("@/views/website/index.vue"),
                children:[
                    {
                        path: "/website/Solution",
                        name: "Solution",
                        meta: { breadcrumb: "解决方案" },
                        component: () => import("@/views/website/Solution/index.vue"),
                    },{
                        path: "/website/register",
                        name: "register",
                        meta: { breadcrumb: "报名方案" },
                        component: () => import("@/views/website/register/index.vue"),
                    },
                ]
            },
            {
                path: "/apply",
                name: "apply",
                meta: { breadcrumb: "申请管理" },
                component: () => import("@/views/Apply/index.vue"),
                children:[
                    {
                        path: "/apply/CityAgent",
                        name: "CityAgent",
                        meta: { breadcrumb: "代理申请" },
                        component: () => import("@/views/Apply/CityAgent/index.vue"),
                    },
                    {
                        path: "/apply/JobRecruitment",
                        name: "JobRecruitment",
                        meta: { breadcrumb: "招聘申请" },
                        component: () => import("@/views/Apply/JobRecruitment/index.vue"),
                    },
                ]
            },
            {
                path: "/article",
                name: "article",
                meta: { breadcrumb: "文章管理" },
                component: () => import("@/views/Article/index.vue"),
                children:[
                    {
                        path: "/article/news",
                        name: "News",
                        meta: { breadcrumb: "新闻中心" },
                        component: () => import("@/views/Article/news/index.vue"),
                    },
                ]
            },
            {
                path: "/stock",
                name: "stock",
                meta: { breadcrumb: "库存管理" },
                component: () => import("@/views/Stock/index.vue"),
                children:[
                    {
                        path: "/stock/Goods",
                        name: "Goods",
                        meta: { breadcrumb: "货物列表" },
                        component: () => import("@/views/Stock/Goods/index.vue"),
                    },
                    {
                        path: "/stock/Category",
                        name: "Category",
                        meta: { breadcrumb: "类目管理" },
                        component: () => import("@/views/Stock/Category/index.vue"),
                    },
                    {
                        path: "/stock/Outbound",
                        name: "CityAgent",
                        meta: { breadcrumb: "出库管理" },
                        component: () => import("@/views/Stock/Outbound/index.vue"),
                    },
                    {
                        path: "/stock/Inbound",
                        name: "Inbound",
                        meta: { breadcrumb: "入库管理" },
                        component: () => import("@/views/Stock/Inbound/index.vue"),
                    },
                    {
                        path: "/stock/Warehouse",
                        name: "Warehouse",
                        meta: { breadcrumb: "仓库库存" },
                        component: () => import("@/views/Stock/Warehouse/index.vue"),
                    },

                ]
            },
            {
                path: "/PersonalCenter",
                name: "PersonalCenter",
                component: () => import("@/views/PersonalCenter/index.vue"),
                meta: { breadcrumb: "个人中心" },
            },
            {
                path: "/system",
                name: "system",
                meta: { breadcrumb: "系统管理" },
                component: () => import("@/views/System/index.vue"),
                children: [
                    {
                        path: "/system/dict",
                        name: "system/dict",
                        component: () => import("@/views/System/dict/index.vue"),
                        meta: { breadcrumb: "字典管理" },
                    },
                    {
                        path: "/system/dep",
                        name: "system/dep",
                        component: () => import("@/views/System/dep/index.vue"),
                        meta: { breadcrumb: "部门管理" },
                    },
                    {
                        path: "/system/user",
                        name: "system/user",
                        component: () => import("@/views/System/user/index.vue"),
                        meta: { breadcrumb: "用户管理" },
                    },
                    {
                        path: "/system/role",
                        name: "system/role",
                        component: () => import("@/views/System/role/index.vue"),
                        meta: { breadcrumb: "角色管理" },
                    },
                    {
                        path: "/system/permission",
                        name: "system/permission",
                        component: () => import("@/views/System/permission/index.vue"),
                        meta: { breadcrumb: "权限管理" },
                    },
                ],
            },
            {
                path: "/reimbursement",
                name: "reimbursement",
                meta: { breadcrumb: "报销管理" },
                component: () => import("@/views/Reimbursement/index.vue"),
                children: [
                    {
                        path: "/reimbursement/list",
                        name: "reimbursement/list",
                        component: () => import("@/views/Reimbursement/List/index.vue"),
                        meta: { breadcrumb: "报销列表" },
                    },
                    {
                        path: "/reimbursement/esign",
                        name: "reimbursement/esign",
                        component: () => import("@/views/Reimbursement/ESign/index.vue"),
                        meta: { breadcrumb: "电子签管理" },
                    },
                    {
                        path: "/reimbursement/config",
                        name: "reimbursement/config",
                        component: () => import("@/views/Reimbursement/Config/index.vue"),
                        meta: { breadcrumb: "报销配置" },
                    },
                ],
            },
            {
                path: "/contract",
                name: "contract",
                meta: { breadcrumb: "合同管理" },
                component: () => import("@/views/Contract/index.vue"),
                children: [
                    {
                        path: "/contract/list",
                        name: "contract/list",
                        component: () => import("@/views/Contract/List/index.vue"),
                        meta: { breadcrumb: "合同列表" },
                    },
                    {
                        path: "/contract/config",
                        name: "contract/config",
                        component: () => import("@/views/Contract/Config/index.vue"),
                        meta: { breadcrumb: "审批配置" },
                    },
                ],
            },
            {
                path: "/test",
                name: "test",
                meta: { breadcrumb: "测试" },
                component: () => import("@/views/test/index.vue"),
            },
        ]
    },
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/login.vue"),
        meta: { title: "登陆" },
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('@/views/index.vue'),
        redirect: "/index/HomePage",
        children: [
            {
                path: "HomePage",
                name: "HomePage",
                component: () => import("@/views/indexTab/HomePage.vue"),
                meta: { title: "首页" },
            },
            {
                path: "Solution",
                name: "Solution",
                component: () => import("@/views/indexTab/Solution.vue"),
                meta: { title: "解决方案" },
                // children:[
                //     {
                //         path: "hotel",
                //         name: "hotel",
                //         component: () => import("@/views/indexTab/Solution/hotel.vue"),
                //         meta: { title: "智慧酒店" },
                //     },
                //     {
                //         path: "building",
                //         name: "building",
                //         component: () => import("@/views/indexTab/Solution/building.vue"),
                //         meta: { title: "智慧楼宇" },
                //     },
                // ]
            },
            {
                path: "ProductIntroduction",
                name: "ProductIntroduction",
                component: () => import("@/views/indexTab/ProductIntroduction/index.vue"),
                meta: { title: "产品介绍" },
                redirect: "/index/ProductIntroduction/ProductIntroductionList",
                children:[
                    {
                        path: "ProductIntroductionList",
                        name: "ProductIntroductionList",
                        component: () => import("@/views/indexTab/ProductIntroduction/ProductIntroduction.vue"),
                        meta: { title: "产品列表" },
                    },
                    {
                        path: "Details",
                        name: "Details",
                        component: () => import("@/views/indexTab/ProductIntroduction/Details.vue"),
                        meta: { title: "详情" },
                    },
                ]
            },
            {
                path: "CompanyProfile",
                name: "CompanyProfile",
                component: () => import("@/views/indexTab/CompanyProfile.vue"),
                meta: { title: "公司介绍" },
            },
            {
                path: "ContactUs",
                name: "ContactUs",
                component: () => import("@/views/indexTab/ContactUs.vue"),
                meta: { title: "联系我们" },
            },
        ]
    },
    {
        path: "/register",
        name: "register",
        component: () => import("@/views/Register.vue"),
        meta: { title: "在线报名" },
    },
    {
        path: "/403",
        name: "403",
        component: () => import("@/views/403.vue"),
        meta: { title: "无权限访问" }
    },
    {
        path: "*",
        name: "404",
        component: () => import("@/views/404.vue"),
        meta: { title: "页面不存在" }
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

function hasExternalSalesRole() {
    const userInfo = store.getters.userInfo || {};
    const permissions = store.getters.permissions || [];
    const rolesList = store.getters.rolesList || [];
    const normalize = (val) => String(val || "").trim().toLowerCase();

    const roleCandidates = [];
    const pushRoleKeys = (role) => {
        if (!role || typeof role !== "object") return;
        [
            role.roleKey,
            role.key,
            role.roleCode,
            role.code,
            role.value
        ].forEach((item) => {
            if (item) roleCandidates.push(item);
        });
    };

    if (Array.isArray(rolesList)) rolesList.forEach(pushRoleKeys);
    pushRoleKeys(userInfo);
    if (Array.isArray(userInfo.authRoleDTOList)) {
        userInfo.authRoleDTOList.forEach(pushRoleKeys);
    }
    if (Array.isArray(userInfo.roles)) {
        userInfo.roles.forEach(pushRoleKeys);
    }

    // 地址栏直输或首屏刷新时，兜底读取持久化状态
    try {
        const persisted = JSON.parse(localStorage.getItem("vuex") || "{}");
        if (Array.isArray(persisted.rolesList)) persisted.rolesList.forEach(pushRoleKeys);
        if (persisted.userInfo && typeof persisted.userInfo === "object") {
            pushRoleKeys(persisted.userInfo);
            if (Array.isArray(persisted.userInfo.authRoleDTOList)) {
                persisted.userInfo.authRoleDTOList.forEach(pushRoleKeys);
            }
            if (Array.isArray(persisted.userInfo.roles)) {
                persisted.userInfo.roles.forEach(pushRoleKeys);
            }
        }
    } catch (e) {
        // ignore persisted parse errors
    }

    const target = "sys:externalsales";
    const roleMatch = roleCandidates.some((item) => normalize(item) === target);
    const permissionFallback = permissions.some((item) => normalize(item) === target);
    return roleMatch || permissionFallback;
}

// 白名单
const whiteList = [
    '/index',
    '/index/HomePage',
    '/index/Solution',
    '/index/Solution/hotel',
    '/index/Solution/building',
    '/index/ProductIntroduction',
    '/index/ProductIntroduction/ProductIntroductionList',
    '/index/ProductIntroduction/Details',
    '/index/CompanyProfile',
    '/index/ContactUs',
    '/register',
    '/403',
    '/404',
    '/home',
    '/login'
]

// 优化后的全局路由守卫
router.beforeEach((to, from, next) => {
    // 设置网页标题（后台用 breadcrumb，前台/登录等用 title，统一取其一）
    const pageTitle = to.meta.title || to.meta.breadcrumb
    if (pageTitle) {
        document.title = pageTitle
    }
    console.log(pageTitle, '=====')

    // 关键：优先从Vuex获取token，Cookie兜底（确保已登录状态识别准确）
    const token = store.getters.token || Cookies.get('token');
    // 关键1：识别登录后合法跳转（从login页带token跳转到非login页）
    const isLoginRedirect = from.path === '/login' && token && to.path !== '/login';

    // 关键2：已登录用户访问login页，直接跳转到管理页（/home），而非首页
    if (token && to.path === '/login') {
        // 使用replace+立即next，避免重定向警告
        next({ path: '/home', replace: true });
        return; // 终止后续逻辑，防止重复next
    }

    if (token) {
        // 特殊角色限制：外部销售角色统一进入 403（403/404/login 本身放行，避免重定向循环）
        if (
            to.path !== '/403' &&
            to.path !== '/404' &&
            to.path !== '/login' &&
            hasExternalSalesRole()
        ) {
            next({ path: '/403', replace: true });
            return;
        }

        // 已登录：放行所有非login页的跳转（包括登录后的合法跳转）
        if (isLoginRedirect) {
            next();
        } else {
            next();
        }
    } else {
        // 未登录：白名单放行，其他拦截跳登录
        if (whiteList.includes(to.path)) {
            next();
        } else {
            next({
                path: '/login',
                query: { redirect: to.fullPath },
                replace: true
            });
        }
    }
})

export default router